module.exports = __webpack_public_path__ + "static/img/a1.c7128492.jpg";